import { FEMALE_CHEF_ICON, SOCIAL_IMPACT_ICON, SUSTAINABLE_RESTAURANT_ICON, HEALTH_FOCUSED_ICON, NEXT_GEN_ICON } from "../../uber-assets/inline-svgs";

const FEMALE_CHEF_OF_THE_YEAR = {
    id: 'female_chef',
    label: 'Women in Food Award',
    icon: 'tb_women.png',
    svgIcon: FEMALE_CHEF_ICON,
    match: ['femalechef', 'female', 'f'],
}
const SUSTAINABLE_RESTAURANT_OF_THE_YEAR = {
    id: 'sustainable_restaurant',
    label: 'Climate Impact Award',
    icon: 'tb_climate.png',
    svgIcon: SUSTAINABLE_RESTAURANT_ICON,
    match: ['sustainablerestaurant', 'sustainable', 's'],
}
const SOCIAL_IMPACT_RESTAURANT_OF_THE_YEAR = {
    id: 'social_impact',
    label: 'Social Impact Award',
    icon: 'tb_social.png',
    svgIcon: SOCIAL_IMPACT_ICON,
    match: ['socialimpact', 'social', 'si', 'c', 'community'],
}
const HEALTH_FOCUSED_RESTAURANT_OF_THE_YEAR = {
    id: 'health_focused',
    label: 'Healthy Eats Award',
    icon: 'tb_healthy.png',
    svgIcon: HEALTH_FOCUSED_ICON,
    match: ['healthfocused', 'health', 'h'],
}
const NEXT_GEN_AWARD = {
    id: 'next_gen',
    label: 'Next Gen Award',
    icon: 'tb_nextgen.png',
    svgIcon: NEXT_GEN_ICON,
    match: ['nextgen', 'next', 'ng', 'nextgeneration'],
}
const GAME_CHANGER_AWARD = {
    id: 'game_changer',
    label: 'Gamechanger Award',
    icon: 'tb_nextgen.png',
    svgIcon: NEXT_GEN_ICON,
    match: ['gamechanger', 'game', 'gc', 'gamechangeraward'],
}
const TITAN_TRAILBLAZER_AWARD = {
    id: 'titan_trailblazer',
    label: 'Titan Trailblazer Award',
    icon: 'tb_healthy.png',
    svgIcon: HEALTH_FOCUSED_ICON,
    match: ['titantrailblazer', 'titan', 'tt', 'titantrailblazeraward'],
}

export const TRAILBLAZER_CATEGORIES = {
    female_chef: FEMALE_CHEF_OF_THE_YEAR,
    sustainable_restaurant: SUSTAINABLE_RESTAURANT_OF_THE_YEAR,
    health_focused: HEALTH_FOCUSED_RESTAURANT_OF_THE_YEAR,
    social_impact: SOCIAL_IMPACT_RESTAURANT_OF_THE_YEAR,
    next_gen: NEXT_GEN_AWARD,
    game_changer: GAME_CHANGER_AWARD,
    titan_trailblazer: TITAN_TRAILBLAZER_AWARD,
}

export const TRAILBLAZER_BUTTONS = [
    /* {
        label: 'Women in Food Award',
        category: FEMALE_CHEF_OF_THE_YEAR,
        description: 'Honouring exceptional female talent and their contributions to the restaurant industry.',
    }, */
    {
        label: 'Gamechanger',
        category: NEXT_GEN_AWARD,
        description: 'Recognising a best-in-class, medium-sized restaurant that has had a huge impact on the food industry over the past five years.',
    },
    /* {
        label: 'Climate Impact Award',
        category: SUSTAINABLE_RESTAURANT_OF_THE_YEAR,
        description: 'Recognising restaurants championing environmental sustainability and eco-friendly practices.',
    },
    {
        label: 'Social Impact Award',
        category: SOCIAL_IMPACT_RESTAURANT_OF_THE_YEAR,
        description: 'Acknowledging restaurants making a positive difference in their communities.',
    }, */
    {
        label: 'Titan Trailblazer',
        category: HEALTH_FOCUSED_RESTAURANT_OF_THE_YEAR,
        description: 'Recognising a restaurant or individual that has made a meaningful impact on their community over the past five years, whether by supporting local causes, raising the bar on issues like sustainability, or building best-in-class teams.',
    },
    
]

export function findCategoryData(search) {
    search = search.toLowerCase();
    // replace - with '' in the search string
    search = search.replace(/-/g, '');
    if (TRAILBLAZER_CATEGORIES[search]) {
        return TRAILBLAZER_CATEGORIES[search];
    }
    for (const key in TRAILBLAZER_CATEGORIES) {
        const k = key.replace(/_/g, '');
        if (k === search) {
            return TRAILBLAZER_CATEGORIES[key];
        }
        const category = TRAILBLAZER_CATEGORIES[key];
        if (category.match === search) {
            return category;
        }
        if (Array.isArray(category.match) && category.match.includes(search)) {
            return category;
        }
    }
    return null;
}
